angular.module('eficienciaFiscalModule')
    .factory('promptFactory', ['$timeout', '$compile', '$rootScope', 'validateService', function ($timeout, $compile, $rootScope, validateService) {

        return function (title, inputLabel, callback, inputAttrs, dialogOptions, scope, helpText) {

            var defaultDialogOptions = {
                width: 300,
                modal: true,
                resizable: false
            };

            dialogOptions = angular.extend(defaultDialogOptions, dialogOptions);

            var inputHtml = "<input ng-init='value = undefined' ng-model='value'";

            angular.forEach(inputAttrs, function (value, key) {
                inputHtml += " " + key + "='" + value + "'"
            });

            inputHtml += '>';

            var dialogHtml =
                "<div>" +
                "<form role='form' class='smart-form' style='padding: 20px 0' novalidate>" +
                "   <section class='col col-xs-12'>" +
                "       <label class='label'>" + inputLabel + " </label>" +
                "       <label class='input'>" + inputHtml + "</label>" +
                (helpText ? "       <p style='margin-top: 5px'><small class='text-muted'>" + helpText + "</small></p>" : "") +
                "   </section>" +
                "</form>" +
                "<div class='pull-right margin-bottom-10 margin-top-10'>" +
                "   <button class='btn btn-sm btn-primary' ng-click='submit(value, $event)'>" +
                "       OK" +
                "   </button>" +
                "   <button class='btn btn-sm' ng-click='closeDialog()'>" +
                "       Cancelar" +
                "   </button>" +
                "</div>" +
                "</div>";

            dialogOptions.title = title;

            var dialog = $(dialogHtml);

            dialog.dialog(dialogOptions);

            var $scope;
            if (scope)
                $scope = scope;
            else
                $scope = $rootScope.$new(true);

            $scope.closeDialog = function () {
                dialog.dialog('close');
            };

            $scope.submit = function (value, event) {
                if (validateService.validate($scope, dialog)) {
                    var _return = callback(value, event);
                    if (_return && _return.then)
                        _return.then(function () {
                            $scope.closeDialog()
                        });
                    else
                        $scope.closeDialog()
                }
            };

            $timeout(function () {
                dialog.html($compile(dialog.html())($scope))
            })
        }

    }
    ]);
